import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Fingerprint, Trash2, WifiOff, ShieldCheck, Check, UserX, HeartPulse, Globe, ArrowRight } from 'lucide-react';
import { reveal } from './Showcase';

const CARDS = [
  [Lock, 'PIN Protection', 'Lock the app with your own 4-digit PIN.'],
  [Fingerprint, 'Optional Fingerprint / Face Unlock', "Quick access with your device's biometrics."],
  [Trash2, 'Erases After Your Shift', 'Tap End Shift to erase now, or it erases automatically 2 hours after your shift ends, when the app is open.'],
  [WifiOff, 'Core Tools Work Offline', 'After the first load, your sheet, calculators and references keep working without signal.'],
];

const CHECKS = ['No account required', 'No IT setup', 'No cloud sync', 'You choose what you share'];

const BOTTOM = [
  [UserX, 'No account required'],
  [HeartPulse, 'Made for nurses'],
  [Globe, '18 languages'],
  [ShieldCheck, 'Simple. Secure. Made for your shift.'],
];

const PrivacyCard = ([Icon, title, body], i) => (
  <motion.article {...reveal(i + 1)} key={title} className="lp-pv__card" data-testid={`privacy-point-${i + 1}`}>
    <Icon size={30} strokeWidth={1.8} />
    <h3>{title}</h3>
    <p>{body}</p>
  </motion.article>
);

export const PrivacyPromise = () => (
  <section id="privacy" className="lp-pv" data-testid="privacy-section">
    <div className="lp-pv__inner">
      <motion.figure {...reveal()} className="lp-pv__photo">
        <img src="/landing/nurse-privacy.webp" alt="Nurse in blue scrubs smiling at her phone" width="436" height="798" loading="lazy" data-testid="privacy-nurse-photo" />
      </motion.figure>
      <div className="lp-pv__body">
        <motion.div {...reveal()} className="lp-pv__head">
          <h2 className="lp-pv__title" data-testid="privacy-title">Designed with <em>Nurse Privacy</em> in Mind</h2>
          <p>Your shift notes are saved on your phone, not on our servers.</p>
          <span className="lp-pv__ribbon" data-testid="privacy-ribbon">No account · No cloud sync · No analytics</span>
        </motion.div>
        <div className="lp-pv__cards">{CARDS.map(PrivacyCard)}</div>
        <motion.div {...reveal(2)} className="lp-pv__band" data-testid="privacy-band">
          <ShieldCheck size={56} className="lp-pv__shield" />
          <div>
            <h3>Nothing Stored on Our Servers</h3>
            <p>ShiftReady LLC has no servers that receive or store your shift notes. What you enter is kept on your device. Voice dictation is handled by Apple or Google.</p>
          </div>
          <ul>{CHECKS.map((c) => <li key={c}><Check size={16} strokeWidth={3} /> {c}</li>)}</ul>
        </motion.div>
        <motion.div {...reveal(3)} className="lp-pv__foot">
          <ul>{BOTTOM.map(([Icon, label]) => <li key={label}><Icon size={22} /> {label}</li>)}</ul>
          <a href="#download" className="lp-pv__cta" data-testid="privacy-try-btn">Try ShiftReady free <ArrowRight size={18} /></a>
        </motion.div>
        <a href="/privacy" className="lp-pv__policy" data-testid="privacy-policy-link">Read our Privacy Policy →</a>
      </div>
    </div>
  </section>
);
